import React from 'react';

const GalleryBanner = () =>{
    return (
        <>
        <div className='cadGalleryBanner cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/gallery-banner.webp"
            alt="gallery-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>Gallery</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default GalleryBanner;